import React from "react";
import "./BusPreBookSkeleton.css";

const BusPreBookSkeleton = () => {
  return (
    <div className="busPreBookSkeleton">
      {/* Top Banner */}
      <div className="busPreBookSkeleton-banner shimmer" />

      <div className="busPreBookSkeleton-main">
        <div className="busPreBookSkeleton-left">
          {/* Bus Details Card */}
          <div className="skeleton-card shimmer">
            <div className="skeleton-title" />
            <div className="skeleton-row">
              <div className="skeleton-circle" />
              <div className="skeleton-text short" />
            </div>
            <div className="skeleton-row">
              <div className="skeleton-circle" />
              <div className="skeleton-text long" />
            </div>
          </div>

          {/* Traveller Inputs */}
          {Array.from({ length: 2 }).map((_, idx) => (
            <div key={idx} className="skeleton-traveller-row shimmer">
              <div className="skeleton-select" />
              <div className="skeleton-input" />
              <div className="skeleton-input" />
              <div className="skeleton-input small" />
            </div>
          ))}
          
          {Array.from({ length: 2 }).map((_, idx) => (
            <div key={idx} className="skeleton-traveller-row shimmer">
              <div className="skeleton-select" />
              <div className="skeleton-input" />
              <div className="skeleton-input" />
              <div className="skeleton-input small" />
            </div>
          ))}
          {/* Email & Mobile */}
          <div className="skeleton-input shimmer" />
          <div className="skeleton-input shimmer" />
        </div>
        

        <div className="busPreBookSkeleton-right">
          <div className="skeleton-card shimmer">
            <div className="skeleton-title" />
            <div className="skeleton-text short" />
            <div className="skeleton-text long" />
            <div className="skeleton-button" />
          </div>
        </div>
      </div>

      {/* Mobile Skeleton */}
      <div className="busPreBookSkeleton-mobile">
        <div className="skeleton-card shimmer">
          <div className="skeleton-title" />
          <div className="skeleton-text long" />
          <div className="skeleton-input" />
          <div className="skeleton-input" />
        </div>
      </div>
    </div>
  );
};

export default BusPreBookSkeleton;
